import closeIcon from '@disy/cadenza-icons/close.svg';

import { Action } from 'cadenza/action';
import { icon } from 'cadenza/utils/icon/icon';
import { VIEW } from 'cadenza/map-dashboard/event-types';
import type { TableView } from 'cadenza/map-dashboard/table-view/table-view';

import i18n from '../messages.properties';

export class CloseTableAction extends Action {

  constructor () {
    super({ label: i18n('close'), icon: icon(closeIcon) });
  }

  override executeSync () {
    const tableView = document.querySelector<TableView>('d-table-view')!;
    tableView.dispatchEvent(new CustomEvent(VIEW.TOGGLE_TABLE_VISIBILITY, { detail: { 'isVisible': false }, bubbles: true }));
  }

  override isSupportedSync () {
    return true;
  }

}
